import { ApplicationState } from 'ducks/application-state';

export const selectTenders = (state: ApplicationState) => state.tenders.list;
export const selectTenderRevoke = (state: ApplicationState) => state.tenders.isRevoke;
export const selectTenderOffer = (state: ApplicationState) => state.tenders.offer;
export const selectTendersPagination = (state: ApplicationState) => state.tenders.pagination;
export const selectTendersSort = (state: ApplicationState) => state.tenders.sort;
export const selectTendersLoading = (state: ApplicationState) => state.tenders.loading;
